import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  pageContainer: {
    marginBottom: theme.spacing(5),
  },
  breadcrumbContainer: {
    margin: "75px auto 0px auto",
    maxWidth: "1350px",
    display: "flex",
  },
  customLink: {
    textDecoration: "none",
    color: theme.palette.text.tertiary,
    "&:hover": {
      color: theme.palette.text.primary,
      textDecoration: "none",
    },
  },
  fontLink: {
    fontFamily: "Montserrat",
    fontWeight: "500",
    fontStyle: "normal",
    fontSize: "16px",
    lineHeight: "26px",
  },

  headerBox: {
    textAlign: "left",
    marginBottom: theme.spacing(6),
  },

  pageTitle: {
    fontSize: "3.5rem",
    fontWeight: 800,
    letterSpacing: "-0.02em",
    marginBottom: theme.spacing(1),

    color: theme.palette.text.invesment,
    [theme.breakpoints.down("sm")]: {
      fontSize: "2.5rem",
    },
  },

  titleHighlight: {
    color: "#06e89f",
  },

  pageDescription: {
    color: theme.palette.text.investementDescription,
    fontSize: "1.125rem",
    maxWidth: 600,
    lineHeight: 1.6,
  },

  mainContent: {
    alignItems: "stretch",
  },

  leftColumn: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
  },

  rightColumn: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
  },

  disclaimerText: {
    color: theme.palette.text.disclaimerText,
    fontSize: "0.75rem",
    lineHeight: 1.5,
    marginTop: theme.spacing(3),
    textAlign: "left",
  },

  buttonsContainer: {
    marginTop: theme.spacing(3),
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
  },

  continueButton: {
    backgroundColor: "#06e89f",
    color: "#006341",
    borderRadius: 16,
    padding: "16px 24px",
    fontWeight: 800,
    textTransform: "none",
    fontSize: 15,
    letterSpacing: "0.5px",
    border: "none",
    transition: "all 0.3s ease",
    "&:hover": {
      backgroundColor: "#05d691",
      transform: "translateY(-2px)",
      boxShadow: "0 8px 24px rgba(6, 232, 159, 0.3)",
    },
    "&:active": {
      transform: "translateY(0)",
    },
    "&:disabled": {
      backgroundColor: "rgba(6, 232, 159, 0.3)",
      color: "rgba(0, 99, 65, 0.5)",
    },
  },

  backButton: {
    color: theme.palette.text.investementItem,
    borderRadius: 16,
    padding: "12px 24px",
    border: `0.1px solid ${theme.palette.text.backButton}`,
    textTransform: "none",
    fontSize: 14,
    fontWeight: 600,
    transition: "all 0.3s ease",
    "&:hover": {
      backgroundColor: "rgba(223, 224, 255, 0.05)",
      borderColor: "rgba(223, 224, 255, 0.4)",
      transform: "translateY(-2px)",
    },
  },

  alertContainer: {
    marginTop: theme.spacing(4),
  },
}));

export default useStyles;
